
import { Vue, Component } from 'vue-property-decorator';
import { schools } from '../utils/schools';
@Component
export default class ShowCollegeDetail extends Vue {
  currItem: any;
  logo: string = '';
  bgs = '';
  constructor() {
    super();
    this.currItem = schools.find((item: any) => {
      return item.name === this.$route.query.name;
    });
    // this.init();
  }
  async created() {
    await this.init();
  }
  async init() {
    if (this.currItem.tag) {
      const _ = this;
      this.logo = await import(`../assets/show/${this.currItem.tag}-t.png`).then((res) => {
        return res.default;
      });
      this.bgs = await import(`../assets/show/${this.currItem.tag}-b.png`).then((res) => {
        return res.default;
      });
    }
  }
  goto() {
    this.$router.push(this.currItem.path);
  }
}
